module.exports = __webpack_public_path__ + "static/media/404.11dd34df.png";